import {TypeDataFilter} from '@wearesection/bandai-react-components/organisms/ScrollingFilterListing';
import {ssrGetFilterBy} from '~/graphql/operations/filter-by/filter-by-query.generated';
import {handleRemoveDuplicateItem} from '~/utils';
import * as Types from '../../graphql/types';

export const handleFormatParamFilter = (
  listParamFilter: Types.FilterByCollection,
  dataTranslation: any = {},
  isStore?: boolean
): TypeDataFilter[] => {
  const result: any[] = [];
  const listItemFilter = listParamFilter.items;

  const objFilter: any = {};
  if (listItemFilter.length) {
    listItemFilter.map(item => {
      if (item?.type?.title) {
        if (objFilter[item.type?.title]) {
          const valueFilter = {
            title: item?.title,
            name: isStore ? item?.keyFilterForBg || item?.keyFilter : item?.keyFilter,
            isChecked: false,
          };
          objFilter[item.type?.title]?.dataFilter.push(valueFilter);
          objFilter[item.type?.title].value = item?.typeFilter;
        } else {
          const valueFilter = {
            title: item?.title,
            name: isStore ? item?.keyFilterForBg || item?.keyFilter : item?.keyFilter,
            isChecked: false,
          };
          objFilter[item.type?.title] = {
            title: item?.type?.title,
            dataFilter: [valueFilter],
            countSelect: 0,
            showMore: false,
          };
        }
      }
    });
  }
  const newObjFilter: any = {};
  if (Object.values(objFilter).length) {
    for (const [key, value] of Object.entries(objFilter)) {
      if (key === dataTranslation['filter-game-platform']) {
        newObjFilter[0] = value;
      }
      if (key === dataTranslation['filter-game-genre']) {
        newObjFilter[1] = value;
      }
    }
  }

  if (Object.values(newObjFilter).length) {
    Object.values(newObjFilter).map((filter: any) => {
      const newDataFilter = filter?.dataFilter.sort((a: any, b: any) => {
        if (b.title < a.title) {
          return 1;
        }
        return -1;
      });
      result.push({...filter, dataFilter: handleRemoveDuplicateItem(newDataFilter ?? [], 'title')});
      return null;
    });
  }
  //Handle change position item filter
  const dataCut = result && result[0]?.dataFilter.splice(1, 3);
  if (result[0]?.dataFilter.concat(dataCut) !== undefined) {
    result[0].dataFilter = result[0].dataFilter.concat(dataCut) ?? '';
  }

  return result;
};

async function getParamFilterBy(locale?: string, where = {}) {
  const {
    props: {data},
  } = await ssrGetFilterBy.getServerPage(
    {
      variables: {
        locale,
        where,
      },
    },
    {}
  );

  return data?.filterByCollection;
}

export default getParamFilterBy;
